import React from 'react';
import tw from 'twin.macro';
import { css } from '@emotion/react';
import { useFormContext } from 'react-hook-form';

import CardMain from '$/components/Interactions/cards/CardMain';
import RadioInput from '$/components/ui/Input/Basics/RadioInput';

import { emojiList, getEmoji } from '$/utils/emoji';

import type { InteractionInfo } from '../InteractionInfo';
import Form from '$/components/ui/Form';

export const FeedbackIcons: React.FC<{
  large?: boolean;
  interaction?: InteractionInfo;
  setFeedbackSelected?: (val: number) => void;
  setIsDisabled?: (val: boolean) => void;
  feedbackSelected?: number;
  isEdit: boolean;
}> = ({ large, interaction, setFeedbackSelected, setIsDisabled, feedbackSelected, isEdit }) => {
  const { setValue } = useFormContext();
  React.useEffect(() => {
    if (
      interaction?.reaction?.numberAnswer === undefined ||
      interaction?.reaction?.numberAnswer === null
    ) {
      return;
    }
    setFeedbackSelected && setFeedbackSelected(interaction.reaction.numberAnswer!);
  }, [interaction?.reaction, setFeedbackSelected]);

  const onChangeItem = React.useCallback(
    (value: string): void => {
      if (value !== '0') {
        setFeedbackSelected && setFeedbackSelected(Number(value));
        setIsDisabled && setIsDisabled(false);
        setValue('numberAnswer', value, { shouldDirty: true });
      }
    },
    [setFeedbackSelected, setIsDisabled, setValue]
  );

  return (
    <div className='flex w-full justify-center'>
      <div className={`flex w-full  justify-around ${large ? 'max-w-25e' : 'max-w-15e'}`}>
        <Form.Field
          name='numberAnswer'
          component={
            <div className='flex justify-around'>
              {emojiList.map((icon: string, index: number) => (
                <div
                  css={css`
                    ${tw`flex flex-col items-center justify-center text-center mb-2`}
                    .emoji-mart-emoji {
                      ${tw`flex justify-center my-2`}
                    }
                    .radio.checkbox {
                      min-width: 1rem;
                    }
                  `}
                  key={icon}
                >
                  <div
                    className={`${large && 'text-lg'}`}
                    css={css`
                      margin-bottom: 0;
                      color: ${feedbackSelected === index + 1 ? '#53a3a8' : '#537175'};
                    `}
                  >
                    {index + 1}
                  </div>
                  <CardMain.Emoji size={large ? 30 : undefined} emoji={getEmoji(index + 1)} />
                  <RadioInput
                    name='numberAnswer'
                    value={index + 1}
                    checked={feedbackSelected === index + 1}
                    disabled={isEdit}
                    onChange={onChangeItem}
                  />
                </div>
              ))}
            </div>
          }
        />
      </div>
    </div>
  );
};
